import React from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface AddButtonProps {
  theme?: 'light' | 'dark';
  type?: 'small' | 'large';
  beforeIcon?: React.ReactNode;
  afterIcon?: React.ReactNode;
  text?: string;
  onClick: () => void;
}

const AddButton = ({ theme, type, beforeIcon, afterIcon, text, onClick }: AddButtonProps) => {
  return (
    <button className={cx('btn', theme, type)} type="button" onClick={onClick}>
      {beforeIcon}
      <span className={cx('listText')}>{text}</span>
      {afterIcon}
    </button>
  );
};

export default AddButton;
